// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PhotosUploadScreen":"qg_a bgu_cw bgu_px bgu_a bgu_w"};